"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AWSourceVideo_1 = require("./AWSourceVideo");
const cast_1 = require("../../../utilites/cast");
class AWSourceVimeo extends AWSourceVideo_1.AWSourceVideo {
    constructor() {
        super('vimeo');
    }
    static fromVimeoEmbed(url, vimeo) {
        const obj = {
            url,
            type: 'vimeo',
            duration: vimeo.duration,
            resolution: { w: vimeo.width, h: vimeo.height },
            thumbnail: {
                url: vimeo.thumbnail_url,
                resolution: { w: vimeo.thumbnail_width, h: vimeo.thumbnail_height }
            }
        };
        return cast_1.castToType(obj, AWSourceVimeo);
    }
}
exports.AWSourceVimeo = AWSourceVimeo;
AWSourceVimeo.propFactory = Object.assign({}, AWSourceVideo_1.AWSourceVideo.propFactory);
